package com.nonopn.skywatcher.common.app.portfolio.main

import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarUiState
import com.nonopn.skywatcher.design.appbar.FloatingActionButtonState
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.RouteParameterTo

data class NoThunderDetectionSelectedModelState(
    var currentRoute: RouteParameterTo,
    val isSystemDarkMode: Boolean,
    override val appBarState: AppBarState = AppBarState.Regular(),
    override val floatingActionButtonState: FloatingActionButtonState? = null,
    val currentApi: ApiInterface? = null,
) : AppBarUiState
